import React from "react";
import PageShell from "../../components/layout/PageShell";

export default function Realisations() {
  return (
    <PageShell
      title="Réalisations"
      subtitle="Les accomplissements de l'École de la Magistrature"
    >
      {/* Introduction */}
      <section className="ema-block">
        <h2 className="ema-h3">Nos réalisations</h2>
        <p className="ema-paragraph">
          Depuis sa création, l'École de la Magistrature a accompli de nombreuses réalisations dans le domaine
          de la formation des magistrats et du renforcement du système judiciaire haïtien. Voici quelques-unes de
          nos principales réussites.
        </p>
      </section>

      <div className="ema-divider" />

      {/* Formations */}
      <section className="ema-block">
        <h2 className="ema-h3">Formations dispensées</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Formation initiale</h3>
            <p className="ema-paragraph">
              8 promotions de magistrats formées depuis 2016, avec un total de plus de 350 diplômés exerçant
              dans les tribunaux de tout le pays.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Formation continue</h3>
            <p className="ema-paragraph">
              Plus de 50 sessions de formation continue dispensées aux magistrats en fonction, couvrant des
              thématiques variées en droit et en pratique judiciaire.
            </p>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Partenariats */}
      <section className="ema-block">
        <h2 className="ema-h3">Partenariats développés</h2>
        <div className="ema-grid-3" style={{ marginTop: 14 }}>
          <div className="ema-card ema-card-highlight">
            <h3 className="ema-h3">Partenariats nationaux</h3>
            <p className="ema-paragraph">
              Collaboration avec le Ministère de la Justice, la Cour de Cassation et les tribunaux pour les
              stages et la formation pratique.
            </p>
          </div>
          <div className="ema-card ema-card-highlight">
            <h3 className="ema-h3">Partenariats internationaux</h3>
            <p className="ema-paragraph">
              Accords avec des organisations internationales et des écoles de magistrature étrangères pour
              l'échange de bonnes pratiques.
            </p>
          </div>
          <div className="ema-card ema-card-highlight">
            <h3 className="ema-h3">Partenariats académiques</h3>
            <p className="ema-paragraph">
              Relations avec les facultés de droit et les institutions académiques pour le développement de la
              recherche juridique.
            </p>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Projets spéciaux */}
      <section className="ema-block">
        <h2 className="ema-h3">Projets spéciaux</h2>
        <div className="ema-timeline" style={{ marginTop: 14 }}>
          <Timeline n="1" title="Programme de formation probatoire" text="Formation spécifique pour les juges de paix nouvellement nommés." />
          <Timeline n="2" title="Renforcement des compétences numériques" text="Introduction des technologies de l'information dans la pratique judiciaire." />
          <Timeline n="3" title="Formation en droit de l'environnement" text="Programme spécialisé sur les questions environnementales et climatiques." />
          <Timeline n="4" title="Programme de mentorat" text="Accompagnement des jeunes magistrats par des juges expérimentés." />
        </div>
      </section>

      <div className="ema-divider" />

      {/* Reconnaissances */}
      <section className="ema-block">
        <h2 className="ema-h3">Reconnaissances</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Reconnaissance institutionnelle</h3>
            <p className="ema-paragraph">
              L'EMA est reconnue comme l'institution de référence pour la formation des magistrats en Haïti,
              avec la confiance des autorités judiciaires et du gouvernement.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Reconnaissance internationale</h3>
            <p className="ema-paragraph">
              L'excellence de nos programmes de formation est reconnue par nos partenaires internationaux,
              qui soutiennent nos initiatives et collaborent activement avec nous.
            </p>
          </div>
        </div>
      </section>
    </PageShell>
  );
}

function Timeline({ n, title, text }) {
  return (
    <div className="ema-step">
      <div className="ema-step-num">{n}</div>
      <div className="ema-step-body">
        <h3 className="ema-h3" style={{ margin: 0 }}>{title}</h3>
        <p className="ema-paragraph" style={{ marginTop: 10 }}>{text}</p>
      </div>
    </div>
  );
}
